/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var Bookmark = createReactComponent("bookmark", "Bookmark", [["path", { "d": "M7.527 20.841C6.861 21.274 6 20.772 6 19.952V3.942c0-.52.336-.942.75-.942h10.5c.414 0 .75.422.75.942v16.01c0 .82-.861 1.322-1.527.89l-3.946-2.562a.962.962 0 0 0-1.054 0z", "key": "svg-0" }]]);

export { Bookmark as default };
//# sourceMappingURL=Bookmark.js.map
